import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";
import {
  Events,
  Booking,
  Assets,
  Jobs,
  Packages,
  Volunteers,
  Memberships,
  MembershipsTransfer,
  TransferMemberReviewStageStatus,
  Competitions,
  CompetitionsCriteria,
  PaymentStatus,
  JobsApplication,
  VolunteerApplication,
  DonationsGiftCardCategories,
  DonationsGiftCardTemplates,
  DonationTransactionStatus,
  DonationDeliveryMethods,
  NewCompetitions,
  NewCompetitionsParticipant,
} from "./status.enums";
@Component({
  selector: "app-status-flag",
  templateUrl: "./status-flag.component.html",
  styleUrls: ["./status-flag.component.scss"],
})
export class StatusFlagComponent implements OnChanges {
  @Input() statusName!: string;
  @Input() statusCode!: number;
  @Input() statusMap!: string;
  @Input() labelTranslationKey: string;
  @Input() labelTranslationModuleEnum: number;
  @Output() status = new EventEmitter();
  private resolvedMap: Record<number, string> = {};

  ngOnChanges(): void {    
    this.statusCode = this.statusCode || 0;
    switch (this.statusMap) {
      case "Events":
        this.resolvedMap = Events;
        break;
      case "Booking":
        this.resolvedMap = Booking;
        break;
      case "Assets":
        this.resolvedMap = Assets;
        break;
      case "Jobs":
        this.resolvedMap = Jobs;
        break;
      case "Packages":
        this.resolvedMap = Packages;
        break;
      case "CompetitionsCriteria":
        this.resolvedMap = CompetitionsCriteria;
        break;
      case "Memberships":
        this.resolvedMap = Memberships;
        break;
      case "MembershipsTransfer":
        this.resolvedMap = MembershipsTransfer;
        break;
      case "TransferMemberReviewStageStatus":
        this.resolvedMap = TransferMemberReviewStageStatus;
        break;
      case "Volunteers":
        this.resolvedMap = Volunteers;
        break;
      case "Competitions":
        this.resolvedMap = Competitions;
        break;
      case "NewCompetitions":
        this.resolvedMap = NewCompetitions;
        break;
      case "NewCompetitionsParticipant":
        this.resolvedMap = NewCompetitionsParticipant;
        break;
        
      case "DonationsGiftCardCategories":
        this.resolvedMap = DonationsGiftCardCategories;
        break;
      case "DonationsGiftCardTemplates":
        this.resolvedMap = DonationsGiftCardTemplates;
        break;
      case "DonationTransactionStatus":
        this.resolvedMap = DonationTransactionStatus;
        break;
      case "DonationDeliveryMethods":
        this.resolvedMap = DonationDeliveryMethods;
        break;
      case "PaymentStatus":
        this.resolvedMap = PaymentStatus;
        break;
      case "JobsApplication":
        this.resolvedMap = JobsApplication;
        break;
      case "VolunteerApplication":
        this.resolvedMap = VolunteerApplication;
        break;
      default:
        break;
    }
  }

  checkStatusCode(statusCode: number): string | null {
    if (typeof statusCode != 'number') return null;
    let status =
      this.resolvedMap?.[statusCode]?.toLocaleLowerCase() ||
      this.statusName?.toLocaleLowerCase()?.split(" ").join("") ||
      null;
    this.status.emit(status);
    return status;
  }
}
